import { z } from 'zod';
import { isoDateTimeSchema, pageQuerySchema, uuidSchema } from './common.js';
/**
 * Audit trail, as read back by an owner or an external accountant.
 *
 * The response is intentionally read-only: there is no create, update or delete
 * endpoint for audit events anywhere in the API, and the database revokes those
 * grants as well.
 */
export const actorTypeSchema = z.enum(['user', 'system', 'service']);
export const auditEventSchema = z.object({
    id: uuidSchema,
    organizationId: uuidSchema.nullable(),
    actorType: actorTypeSchema,
    actorId: uuidSchema.nullable(),
    actorEmail: z.email().nullable(),
    /** `resource.past_tense_verb`, e.g. `membership.role_changed`. */
    action: z.string().min(1),
    resourceType: z.string().min(1),
    resourceId: z.string().nullable(),
    summary: z.string(),
    metadata: z.record(z.string(), z.unknown()),
    requestId: z.string().nullable(),
    occurredAt: isoDateTimeSchema,
});
export const listAuditEventsQuerySchema = pageQuerySchema.extend({
    action: z.string().min(1).optional(),
    resourceType: z.string().min(1).optional(),
    /** With resourceType, narrows the trail to one object — its timeline. */
    resourceId: z.string().min(1).optional(),
    actorId: uuidSchema.optional(),
    /** Inclusive lower bound on `occurredAt`. */
    since: isoDateTimeSchema.optional(),
    /** Exclusive upper bound on `occurredAt`. */
    until: isoDateTimeSchema.optional(),
});
//# sourceMappingURL=audit.js.map